import { makeStyles } from '@material-ui/core/styles';
import { Theme } from '@material-ui/core/styles';
import { createStyles } from '@material-ui/core/styles';
import { observer } from "mobx-react";
import { useEffect, useState } from 'react';
import { Box, Grid, Select, TextField, Typography } from '@material-ui/core';
import { AutocompleteField, Button, MultiSelectField, SelectField, createMultiSelectField, createTextField } from '@roc/ui';
import RichTextWithAttachments from '../../utils/richTextWithAttachments';
import { templatePlaceHolders } from 'libs/feature-communication/src/communication/utils/constants';
import { useUserStore } from "@roc/feature-app-core";
import { HtmlContainer } from '../leadDetails/htmlContainer';
import { MAX_FILE_SIZE } from 'libs/feature-communication/src/communication/utils/constants';
import { divider } from '../contactDetails/contactDetailsComponent';
import { BaseLeadStore } from 'libs/client-portal-shared/src/app/modules/companyProfile/stores/baseLeadStore/BaseLeadStore';
import { BORROWER_OBJECT_TYPE, BROKER_OBJECT_TYPE, leadStatusOptions, TPO_OBJECT_TYPE } from '../leads/constants/constants';
import { useStore } from '@roc/client-portal-shared/hooks';
import { CadencesAutocompleteField } from './cadencesAutocompleteField';
import { Alert } from '@material-ui/lab';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      display: 'flex',
      justifyContent: 'center',
      width: '100%'
    },
    contentContainer: {
      paddingTop: theme.spacing(1),
      paddingBottom: theme.spacing(1),
    },
    previewBox: {
      [theme.breakpoints.up('sm')]: {
        width: '100%'
      },
      [theme.breakpoints.up('lg')]: {
        width: '75%',
      },
    },
    divider: {
      position: 'absolute',
      border: '1px solid grey',
      height: '95%',
      [theme.breakpoints.up('lg')]: {
        left: '53%',
      },
      [theme.breakpoints.down('md')]: {
        left: '50%',
      },
      [theme.breakpoints.down('sm')]: {
        display: 'none',
      },
    },
    modalContainer: {
      position: 'relative'
    }
  })
);

export const AddProspectsToCadence = observer(({ handleClose = () => { }, disableEditTemplateBody, salesforceLeadStore, type, fromGrid = false }: { handleClose, disableEditTemplateBody: boolean, salesforceLeadStore: BaseLeadStore, type, fromGrid?}) => {
  const { cadenceStore } = useStore();

  const classes = useStyles();

  useEffect(() => {
    cadenceStore.getCadenceOptions(type);
  }, [])

  const handleSubmit = () => {
    if (type === BORROWER_OBJECT_TYPE) {
      cadenceStore.addCadenceContacts(salesforceLeadStore.borrowerIds, type, salesforceLeadStore.gridBusinessUnit)
    } else if (type === TPO_OBJECT_TYPE || type === BROKER_OBJECT_TYPE) {
      cadenceStore.addCadenceContacts(salesforceLeadStore.companyContactIds, type, salesforceLeadStore.gridBusinessUnit)
    } else {
      cadenceStore.addCadenceContacts(salesforceLeadStore.leadIds, type, salesforceLeadStore.gridBusinessUnit)
    }
    handleClose();
  }

  return (
    <Grid container>
      <Grid item xs={12} style={{ marginBottom: '10px', marginTop: '-30px' }}>
        <Alert severity="warning"> Any contact with DNC will not be added to the journey. </Alert>
      </Grid>
      <Grid item xs={12} style={{ marginBottom: '10px' }}>
        <CadencesAutocompleteField store={cadenceStore} />
      </Grid>
      <Grid item xs={12} style={{ marginTop: '10px' }}>
        <Box display="flex" justifyContent="flex-end">
          <Button
            color="primary"
            variant="outlined"
            onClick={handleClose}
            style={{ width: '200px', margin: '0 5px' }}
            testId="back"
          >Back</Button>
          <Button
            variant="contained"
            color="primary"
            onClick={handleSubmit}
            style={{ width: '200px', margin: '0 5px' }}
            testId="next"
          >Send</Button>
        </Box>
      </Grid>
    </Grid>
  )
});